(function () {
	const els = document.getElementsByClassName(`typed-text`);
	if (els.length === 0) {
		return;
	}

	if (window.matchMedia(`(prefers-reduced-motion: reduce)`).matches) {
		for (const el of els) {
			el.textContent = el.dataset.text.split(`|`)[0];
		}

		return;
	}

	const type_speed = 80;
	const back_speed = 40;
	const back_delay = 1500;
	const next_delay = 200;
	const cursor_char = `|`;

	const reserve_height = (el) => {
		const heading = el.closest(`h1, h2, h3, h4, h5, h6`);

		if (!heading) {
			return;
		}

		const clone = heading.cloneNode(true);
		clone.style.position = `absolute`;
		clone.style.visibility = `hidden`;
		clone.style.pointerEvents = `none`;
		clone.style.minHeight = `auto`;
		clone.style.width = `${heading.offsetWidth}px`;
		clone.setAttribute(`aria-hidden`, `true`);

		heading.parentElement.appendChild(clone);

		const clone_typed = clone.querySelector(`.typed-text`);
		const strings = el.dataset.text.split(`|`);

		let height = 0;

		for (const string of strings) {
			clone_typed.textContent = string + cursor_char;
			height = Math.max(height, clone.offsetHeight);
		}

		clone.remove();

		heading.style.minHeight = `${height}px`;
	};

	const init = (el) => {
		const strings = el.dataset.text.split(`|`);
		const cursor = document.createElement(`span`);
		cursor.className = `typed-cursor`;
		cursor.textContent = cursor_char;

		let timer = null;
		let index = 0;
		let char = 0;
		let deleting = false;
		let has_started = false;

		const served = el.textContent;

		if (served !== `` && served === strings[0]) {
			char = served.length;
			deleting = true;
		}

		const initial_delay = deleting ? back_delay : 0;

		const tick = () => {
			has_started = true;

			const string = strings[index];

			char += deleting ? -1 : 1;
			el.textContent = string.substring(0, char);
			el.appendChild(cursor);

			let delay = deleting ? back_speed : type_speed;

			if (!deleting && char === string.length) {
				deleting = true;
				delay = back_delay;
			} else if (deleting && char === 0) {
				deleting = false;
				index = (index + 1) % strings.length;
				delay = next_delay;
			}

			timer = setTimeout(tick, delay);
		};

		el.typed = {
			start() {
				if (!timer) {
					timer = setTimeout(tick, has_started ? 0 : initial_delay);
				}
			},
			stop() {
				clearTimeout(timer);
				timer = null;
			},
		};
	};

	const options = {
		threshold: 1.0,
		rootMargin: `32px`,
	};

	const callback = (entries) => {
		for (const entry of entries) {
			if (entry.isIntersecting) {
				entry.target.typed.start();
			} else {
				entry.target.typed.stop();
			}
		}
	};

	const observer = new IntersectionObserver(callback, options);

	const reserve = () => {
		for (const el of els) {
			reserve_height(el);
		}
	};

	for (const el of els) {
		reserve_height(el);
		init(el);
		observer.observe(el);
	}

	let reserve_timer = null;

	window.addEventListener(`resize`, () => {
		clearTimeout(reserve_timer);
		reserve_timer = setTimeout(reserve, 250);
	});

	if (document.fonts) {
		document.fonts.ready.then(reserve);
	}
})();
